import { getAllXPaths } from './getAllXPaths'

let lastClickedXpath: string | null = null

export const handleSelectionClick = ({
  event,
  xpath,
  currentSpec,
  selectedElements,
  setSelectedElements,
}: {
  event: React.MouseEvent
  xpath: string
  currentSpec: any[] | undefined
  selectedElements: string[][] | undefined
  setSelectedElements: ((elements: string[][]) => void) | undefined
}) => {
  if (!setSelectedElements) return

  if (event.shiftKey) {
    if (lastClickedXpath) {
      const allPaths = getAllXPaths(currentSpec ?? [])
      const lastIndex = allPaths.indexOf(lastClickedXpath)
      const currentIndex = allPaths.indexOf(xpath)

      const start = Math.min(lastIndex, currentIndex)
      const end = Math.max(lastIndex, currentIndex)

      if (start > -1 && end > -1) {
        const rangePaths = allPaths.slice(start, end + 1)
        const newSelection = rangePaths.map((p) => p.split('.'))

        // Combine with existing selection if ctrl/meta is also pressed
        if (event.ctrlKey || event.metaKey) {
          const combined = [...(selectedElements ?? [])]
          newSelection.forEach((pathArray) => {
            if (!combined.some((p) => p.join('.') === pathArray.join('.'))) {
              combined.push(pathArray)
            }
          })
          setSelectedElements(combined)
        } else {
          setSelectedElements(newSelection)
        }
      }
      lastClickedXpath = null
    } else {
      // If shift is pressed but there's no lastClickedXpath, treat as a normal click
      setSelectedElements([xpath.split('.')])
      lastClickedXpath = xpath
    }
  } else if (event.ctrlKey || event.metaKey) {
    const existingIndex = (selectedElements ?? []).findIndex((p) => p.join('.') === xpath)
    if (existingIndex > -1) {
      const newSelectedElements = [...(selectedElements ?? [])]
      newSelectedElements.splice(existingIndex, 1)
      setSelectedElements(newSelectedElements)
    } else {
      setSelectedElements([...(selectedElements ?? []), xpath.split('.')])
    }
    lastClickedXpath = xpath
  } else {
    setSelectedElements([xpath.split('.')])
    lastClickedXpath = xpath
  }
}
